import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("FrameMissingController connected");

    this.element.addEventListener("turbo:frame-missing", (event) => {
      const { detail: { response, visit } } = event;
      event.preventDefault();
      console.log(response);
      visit(response); // you have to render your "application" layout for this
    });
  }
}
